<div
  class="overlay-section modal-slide"
  [class.slide]="action"
  [class.light-background]="lightBackground">
  <div class="overlay-slide" [class.large-overlay]="added && action">
    <app-sidebar-collapse
      title="{{ collapseTitle }}"
      type="open"
      [icon]="icon"
      background="white"
      (custom_click)="closeOverlay()"></app-sidebar-collapse>
    <div class="d-flex">
      <div class="overlay-content">
        <div
          [class.without-footer]="!overlay_footer"
          [class.big-footer]="bigFooter && overlay_footer"
          [class.small-footer]="smallFooter"
          class="overlay d-flex flex-column spacing-24 custom-scroll">
          <ng-content select="[overlayContent]"></ng-content>
        </div>
        <div [class.large-footer]="bigFooter">
          @if (overlay_footer) {
            <ng-content select="[overlayFooter]"></ng-content>
          }
        </div>
      </div>
      <!-- <div *ngIf="added" class="sidebar-overlay" [class.hide]="!action">
                <ng-content select="[smallOverlay]"></ng-content>
            </div> -->
    </div>
  </div>
</div>
